import "firebase/auth"
import "firebase/firestore"
import "firebase/functions"
import "firebase/database"
import "firebase/analytics"
import "bootstrap/dist/css/bootstrap.min.css"
import { store } from "./src/store/ReduxWrapper"
import { closeUserMenu } from "./src/actions/userMenu"
import React from "react"
import Layout from "./src/components/layout"

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}

export const onRouteUpdate = () => {
  store.dispatch(closeUserMenu()) // whenever route changes close user menu
}

export { default as wrapRootElement } from "./src/store/ReduxWrapper"
